import { Component } from '@angular/core';
import { HeaderComponent } from '../header/header.component';

@Component({
  selector: 'app-productanddescription',
  standalone: true,
  imports: [HeaderComponent],
  templateUrl: './productanddescription.component.html',
  styleUrl: './productanddescription.component.css'
})
export class ProductanddescriptionComponent {

}
